import { MAX_SOURCE_PDF_BYTES, oversizeMessage } from '../../../utils/uploadLimits';

// Advisory only: under this feature's per-file-request architecture, a large
// batch never approaches CloudFront's 1GB *per-request* cap since every file
// is its own request — this just warns the user about time/bandwidth.
export const BATCH_WARNING_THRESHOLD_BYTES = 1024 * 1024 * 1024;

export function createCoverFileEntry(file) {
  const oversized = file.size > MAX_SOURCE_PDF_BYTES;
  return {
    id: `${file.name}-${file.size}-${Date.now()}-${Math.random()}`,
    filename: file.name,
    file,
    stages: {
      cover: {
        status: oversized ? 'error' : 'queued',
        progressPct: 0,
        error: oversized ? oversizeMessage(file) : null,
        resultBlob: null,
        dimensionInfo: null,
      },
    },
  };
}
